import {
  PostBillAPIProvider,
  PostBillHistoryProvider,
  PostBillProvider,
  PostbillSessionProvider,
} from "@app/provider";
import React, { ReactNode } from "react";
import { SpinnerView } from "@app/components";
import { PostBillAPIContext } from "@app/provider";

interface PostBillContextWrapperProps {
  children: ReactNode;
}

export const PostBillContextWrapper: React.FC<PostBillContextWrapperProps> = ({
  children,
}) => {
  const PostBillTopSpinner: React.FC = () => {
    const { loadingStates } = React.useContext(PostBillAPIContext);
    return (
      <SpinnerView
        isLoading={
          (loadingStates?.verifyLogin || loadingStates?.submitSurvey) ?? false
        }
      />
    );
  };

  return (
    <PostbillSessionProvider>
      <PostBillProvider>
        <PostBillAPIProvider>
          <PostBillHistoryProvider key={location.pathname}>
            <PostBillTopSpinner />
            {children}
          </PostBillHistoryProvider>
        </PostBillAPIProvider>
      </PostBillProvider>
    </PostbillSessionProvider>
  );
};
